import api from '../api'
import router from '../../router/index'

export default {
  async authUserAction (context, payload) {
    return new Promise((resolve, reject) => {
      api.login(payload.username, payload.password).then((res) => {
        context.commit('authUserCommit', {
          user: res.user,
          token: res.access_token,
          logined: true
        })

        localStorage.setItem('user', JSON.stringify(res.user))
        localStorage.setItem('access_token', res.access_token)

        resolve(res.user)
      }).catch((data) => {
        reject(data.errors)
      })
    })
  },
  authUserLogout (context) {
    context.commit('authUserCommit', {
      user: {},
      token: null,
      logined: false
    })

    localStorage.removeItem('user')
    localStorage.removeItem('access_token')

    // redirect to reload whole page
    router.push({ path: '/auth/sign-in1' })
  },
  getMe (context, payload) {
    api.auth.me().then((res) => {
      localStorage.setItem('user', JSON.stringify(res))
      context.commit('authInfoCommit', res)
    })
  }
}
